import { getSupabaseClient } from '../../../../core/supabase/client.js';

export class FollowRemoteDataSource {
  private get supabase() {
    return getSupabaseClient() as any;
  }

  /** Ids of users that `userId` follows. */
  async listFollowingIds(userId: string): Promise<string[]> {
    const { data, error } = await this.supabase
      .from('user_follows')
      .select('following_id')
      .eq('follower_id', userId);
    if (error) throw new Error(error.message);
    return (data ?? []).map((r: { following_id: string }) => r.following_id);
  }

  /** Ids of users that follow `userId`. */
  async listFollowerIds(userId: string): Promise<string[]> {
    const { data, error } = await this.supabase
      .from('user_follows')
      .select('follower_id')
      .eq('following_id', userId);
    if (error) throw new Error(error.message);
    return (data ?? []).map((r: { follower_id: string }) => r.follower_id);
  }

  async follow(followerId: string, followingId: string): Promise<void> {
    const { error } = await this.supabase
      .from('user_follows')
      .upsert({ follower_id: followerId, following_id: followingId }, { onConflict: 'follower_id,following_id' });
    if (error) throw new Error(error.message);
  }

  async unfollow(followerId: string, followingId: string): Promise<void> {
    const { error } = await this.supabase
      .from('user_follows')
      .delete()
      .eq('follower_id', followerId)
      .eq('following_id', followingId);
    if (error) throw new Error(error.message);
  }
}
